(function () {
  var MOBILE_QUERY = '(max-width: 1024.98px)';
  var CANVAS_SELECTOR = '#main-collection-filters-mobile';
  var GROUP_SELECTOR = 'action-filter';
  var TITLE_SELECTOR = '.filter-title, .filter__title, .facets__summary';
  var PANEL_SELECTOR = '.filter-attribute.vertical-filter, .filter-attribute, .filter-content, .facets__display, .facets__list';
  var CLOSED_CLASS = 'mobile-filter-fix-v14-closed';
  var NORMALIZING_CLASS = 'mobile-filter-fix-v14-normalizing';
  var STYLE_ID = 'mobile-filter-fix-v14-style';
  var DATA_BOUND = 'mobileFilterFixV14Bound';
  var DATA_OBSERVER = 'mobileFilterFixV14ObserverBound';
  var activeGroupKey = null;
  var internalUpdate = false;
  var allowThemeCloseUntil = 0;
  var optionUpdateUntil = 0;

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function getCanvas() {
    return document.querySelector(CANVAS_SELECTOR);
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '@media (max-width: 1024.98px) {',
      CANVAS_SELECTOR + ' .' + CLOSED_CLASS + ' {',
      'display: none !important;',
      'height: 0 !important;',
      'max-height: 0 !important;',
      'overflow: hidden !important;',
      'visibility: hidden !important;',
      'opacity: 0 !important;',
      '}',
      CANVAS_SELECTOR + '.' + NORMALIZING_CLASS + ' *,',
      CANVAS_SELECTOR + ' .' + NORMALIZING_CLASS + ' {',
      'transition: none !important;',
      'animation: none !important;',
      '}',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function findTitle(group) {
    return group ? group.querySelector(TITLE_SELECTOR) : null;
  }

  function findPanel(group) {
    return group ? group.querySelector(PANEL_SELECTOR) : null;
  }

  function isPriceRangeGroup(group) {
    if (!group) {
      return false;
    }

    var title = findTitle(group);
    var label = title ? title.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';

    return Boolean(
      group.querySelector([
        'input[type="range"]',
        'input[name*="price"]',
        'input[id*="price"]',
        'input[class*="price"]',
        '.price-range',
        '.facets__price',
        '.filter-price',
        '.range-slider',
        '.noUi-target'
      ].join(',')) ||
      label === 'price' ||
      label === 'fiyat' ||
      label.indexOf('price') !== -1 ||
      label.indexOf('fiyat') !== -1
    );
  }

  function getGroups() {
    var canvas = getCanvas();

    if (!canvas) {
      return [];
    }

    return Array.prototype.slice.call(canvas.querySelectorAll(GROUP_SELECTOR)).filter(function (group) {
      return Boolean(findTitle(group) && findPanel(group));
    });
  }

  function getGroupKey(group) {
    if (!group) {
      return null;
    }

    var title = findTitle(group);
    var label = title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
    var id = group.getAttribute('id') || group.getAttribute('data-index') || group.getAttribute('data-filter-index') || '';

    return id || label || String(getGroups().indexOf(group));
  }

  function findGroupByKey(key) {
    var match = null;

    getGroups().some(function (group) {
      if (getGroupKey(group) === key) {
        match = group;
        return true;
      }

      return false;
    });

    return match;
  }

  function setTitle(title, shouldOpen) {
    if (!title) {
      return;
    }

    title.classList.toggle('opened', shouldOpen);
    title.classList.toggle('active', shouldOpen);
    title.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
  }

  function openPanel(panel, preserveNativeLayout) {
    if (!panel) {
      return;
    }

    panel.classList.remove(CLOSED_CLASS);

    if (preserveNativeLayout) {
      return;
    }

    panel.style.display = 'block';
    panel.style.height = 'auto';
    panel.style.maxHeight = '';
    panel.style.overflow = '';
    panel.style.visibility = '';
    panel.style.opacity = '';
  }

  function closePanel(panel, preserveNativeLayout) {
    if (!panel) {
      return;
    }

    panel.classList.add(CLOSED_CLASS);

    if (preserveNativeLayout) {
      return;
    }

    panel.style.display = 'none';
    panel.style.height = '0px';
    panel.style.maxHeight = '0px';
    panel.style.overflow = 'hidden';
  }

  function setGroup(group, shouldOpen) {
    var preserveNativeLayout = isPriceRangeGroup(group);

    setTitle(findTitle(group), shouldOpen);

    if (shouldOpen) {
      openPanel(findPanel(group), preserveNativeLayout);
    } else {
      closePanel(findPanel(group), preserveNativeLayout);
    }
  }

  function isGroupOpen(group) {
    var panel = findPanel(group);

    if (!panel) {
      return false;
    }

    return !panel.classList.contains(CLOSED_CLASS) && panel.style.display !== 'none';
  }

  function containsGroup(group, groups) {
    return groups.indexOf(group) !== -1;
  }

  function sameGroups(openGroups) {
    var wanted = openGroups || [];
    var groups = getGroups();

    return groups.every(function (group) {
      return isGroupOpen(group) === containsGroup(group, wanted);
    });
  }

  function applyState(openGroups, silent) {
    if (!isMobile()) {
      return;
    }

    var canvas = getCanvas();
    internalUpdate = true;

    if (silent && canvas) {
      canvas.classList.add(NORMALIZING_CLASS);
    }

    if (sameGroups(openGroups)) {
      if (silent && canvas) {
        window.requestAnimationFrame(function () {
          canvas.classList.remove(NORMALIZING_CLASS);
          internalUpdate = false;
        });
      } else {
        internalUpdate = false;
      }

      return;
    }

    getGroups().forEach(function (group) {
      setGroup(group, containsGroup(group, openGroups || []));
    });

    if (silent && canvas) {
      window.requestAnimationFrame(function () {
        canvas.classList.remove(NORMALIZING_CLASS);
        internalUpdate = false;
      });
    } else {
      internalUpdate = false;
    }
  }

  function hasSelectedInput(group) {
    return Boolean(group.querySelector([
      'input[type="checkbox"]:checked',
      'input[type="radio"]:checked',
      'select option:checked:not([value=""])'
    ].join(',')));
  }

  function hasSelectedLink(group) {
    return Boolean(group.querySelector([
      'a[aria-current="true"]',
      'a[aria-checked="true"]',
      'a[aria-selected="true"]',
      'button[aria-pressed="true"]',
      '[data-filter-active="true"]',
      '[data-selected="true"]',
      '.facets__item--active',
      '.filter-active',
      '.is-selected'
    ].join(',')));
  }

  function getPriceSearchValueSet() {
    if (!window.URLSearchParams) {
      return false;
    }

    var params = new URLSearchParams(window.location.search);
    var isSet = false;

    params.forEach(function (value, key) {
      var normalizedKey = String(key || '').toLowerCase();
      var normalizedValue = String(value || '').trim();

      if (!normalizedValue) {
        return;
      }

      if (
        normalizedKey.indexOf('price') !== -1 ||
        normalizedKey.indexOf('filter.v.price') !== -1 ||
        normalizedKey.indexOf('filter.p.price') !== -1
      ) {
        isSet = true;
      }
    });

    return isSet;
  }

  function parseNumericValue(value) {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    var parsed = Number(String(value).replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : null;
  }

  function priceInputHasValue(input) {
    if (!input || input.disabled) {
      return false;
    }

    var value = String(input.value || '').trim();

    if (!value) {
      return false;
    }

    var valueNumber = parseNumericValue(value);
    var minNumber = parseNumericValue(input.getAttribute('min'));
    var maxNumber = parseNumericValue(input.getAttribute('max'));
    var defaultNumber = parseNumericValue(input.defaultValue);
    var name = String(input.name || input.id || input.className || '').toLowerCase();

    if (defaultNumber !== null && valueNumber !== null && valueNumber !== defaultNumber) {
      return true;
    }

    if ((name.indexOf('gte') !== -1 || name.indexOf('min') !== -1 || name.indexOf('from') !== -1) && minNumber !== null && valueNumber !== null) {
      return valueNumber !== minNumber;
    }

    if ((name.indexOf('lte') !== -1 || name.indexOf('max') !== -1 || name.indexOf('to') !== -1) && maxNumber !== null && valueNumber !== null) {
      return valueNumber !== maxNumber;
    }

    if (input.type === 'range' && minNumber !== null && maxNumber !== null && valueNumber !== null) {
      return valueNumber !== minNumber && valueNumber !== maxNumber;
    }

    return Boolean(
      name.indexOf('price') !== -1 ||
      name.indexOf('amount') !== -1 ||
      name.indexOf('min') !== -1 ||
      name.indexOf('max') !== -1
    );
  }

  function priceGroupHasSelectedValue(group) {
    if (!isPriceRangeGroup(group)) {
      return false;
    }

    if (getPriceSearchValueSet()) {
      return true;
    }

    return Array.prototype.slice.call(group.querySelectorAll([
      'input[type="number"]',
      'input[type="text"]',
      'input[type="hidden"]',
      'input[type="range"]',
      'input[name*="price"]',
      'input[id*="price"]'
    ].join(','))).some(priceInputHasValue);
  }

  function groupHasSelectedOption(group) {
    if (!group) {
      return false;
    }

    if (isPriceRangeGroup(group)) {
      return priceGroupHasSelectedValue(group);
    }

    return hasSelectedInput(group) || hasSelectedLink(group);
  }

  function getSelectedGroups() {
    return getGroups().filter(groupHasSelectedOption);
  }

  function openSelectedGroupsOrCloseAll() {
    var selectedGroups = getSelectedGroups();

    activeGroupKey = selectedGroups.length === 1 ? getGroupKey(selectedGroups[0]) : null;
    applyState(selectedGroups, true);
  }

  function keepOnlyGroup(group) {
    if (!group) {
      return;
    }

    activeGroupKey = getGroupKey(group);

    [0, 40, 120, 260].forEach(function (delay) {
      window.setTimeout(function () {
        var activeGroup = findGroupByKey(activeGroupKey);
        applyState(activeGroup ? [activeGroup] : []);
      }, delay);
    });
  }

  function closeAllGroups() {
    activeGroupKey = null;
    applyState([]);
  }

  function isApplyControl(target) {
    if (!target || !target.closest) {
      return false;
    }

    var control = target.closest('button, input[type="submit"], a');

    if (!control) {
      return false;
    }

    var text = (control.textContent || control.value || '').replace(/\s+/g, ' ').trim().toLowerCase();

    return Boolean(
      control.matches('button[type="submit"], input[type="submit"], button.apply, a.apply, .btn-apply, .filter-apply, [data-action*="apply"], [name="commit"]') ||
      text === 'apply' ||
      text === 'uygula' ||
      text === 'filter' ||
      text === 'filtrele'
    );
  }

  function scheduleSelectedGroupsRestore(allowActiveFallback) {
    [180, 520].forEach(function (delay) {
      window.setTimeout(function () {
        if (!isMobile() || Date.now() < allowThemeCloseUntil) {
          return;
        }

        var selectedGroups = getSelectedGroups();

        if (selectedGroups.length > 0) {
          activeGroupKey = selectedGroups.length === 1 ? getGroupKey(selectedGroups[0]) : null;
          applyState(selectedGroups, true);
          return;
        }

        if (allowActiveFallback && activeGroupKey) {
          var activeGroup = findGroupByKey(activeGroupKey);
          applyState(activeGroup ? [activeGroup] : [], true);
          return;
        }

        activeGroupKey = null;
        applyState([], true);
      }, delay);
    });
  }

  function bindCanvasClicks() {
    var canvas = getCanvas();

    if (!canvas || canvas.dataset[DATA_BOUND] === 'true') {
      return;
    }

    canvas.dataset[DATA_BOUND] = 'true';

    canvas.addEventListener(
      'click',
      function (event) {
        if (!isMobile() || !event.target.closest) {
          return;
        }

        if (isApplyControl(event.target)) {
          allowThemeCloseUntil = Date.now() + 1600;
          activeGroupKey = null;
          return;
        }

        var title = event.target.closest(TITLE_SELECTOR);

        if (title && canvas.contains(title)) {
          var group = title.closest(GROUP_SELECTOR);
          var isPriceGroup = isPriceRangeGroup(group);

          if (isPriceGroup) {
            var priceWasOpen = isGroupOpen(group);

            if (priceWasOpen) {
              activeGroupKey = null;

              window.setTimeout(function () {
                applyState([], true);
              }, 80);
            } else {
              activeGroupKey = getGroupKey(group);

              [80, 220].forEach(function (delay) {
                window.setTimeout(function () {
                  var activeGroup = findGroupByKey(activeGroupKey);
                  applyState(activeGroup ? [activeGroup] : [], true);
                  window.dispatchEvent(new Event('resize'));
                }, delay);
              });
            }

            return;
          }

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          if (isGroupOpen(group)) {
            closeAllGroups();
          } else {
            keepOnlyGroup(group);
          }

          return;
        }

        var optionGroup = event.target.closest(GROUP_SELECTOR);

        if (optionGroup && canvas.contains(optionGroup)) {
          if (isPriceRangeGroup(optionGroup)) {
            return;
          }

          optionUpdateUntil = Date.now() + 900;
          scheduleSelectedGroupsRestore(false);
        }
      },
      true
    );
  }

  function bindDrawerOpenWatch() {
    if (document.documentElement.dataset.mobileFilterFixV14DrawerBound === 'true') {
      return;
    }

    document.documentElement.dataset.mobileFilterFixV14DrawerBound = 'true';

    document.addEventListener(
      'click',
      function (event) {
        if (!isMobile() || !event.target.closest) {
          return;
        }

        if (!event.target.closest('[data-item="overlay-filter"], #filter-icon-buddle, .btn-filter')) {
          return;
        }

        window.setTimeout(openSelectedGroupsOrCloseAll, 80);
        window.setTimeout(openSelectedGroupsOrCloseAll, 240);
        window.setTimeout(openSelectedGroupsOrCloseAll, 520);
      },
      false
    );
  }

  function observeChanges() {
    var canvas = getCanvas();

    if (!canvas || canvas.dataset[DATA_OBSERVER] === 'true') {
      return;
    }

    canvas.dataset[DATA_OBSERVER] = 'true';

    var observer = new MutationObserver(function () {
      if (!isMobile() || internalUpdate || Date.now() < allowThemeCloseUntil) {
        return;
      }

      if (Date.now() < optionUpdateUntil) {
        scheduleSelectedGroupsRestore(false);
        return;
      }

      if (!activeGroupKey) {
        return;
      }

      window.setTimeout(function () {
        var activeGroup = findGroupByKey(activeGroupKey);
        applyState(activeGroup ? [activeGroup] : []);
      }, 40);
    });

    observer.observe(canvas, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      childList: true,
      subtree: true
    });
  }

  function init() {
    injectStyles();
    bindCanvasClicks();
    bindDrawerOpenWatch();
    observeChanges();

    if (isMobile()) {
      window.setTimeout(openSelectedGroupsOrCloseAll, 0);
      window.setTimeout(openSelectedGroupsOrCloseAll, 260);
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('appco-DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
